export default __webpack_public_path__ + "static/media/diners-club.ac189d12.svg";